<template>
  <div id="reportWrapper">
    <h1 class="title">{{ report.name }}</h1>

    <div class="field">
      <label for="name">Naam rapport</label>
      <div class="control">
        <input name="name" class="input" type="text" v-model="name">
      </div>
    </div>

    <hr>

    <div class="columns">
      <div class="column">
        <nav class="panel">
          <p class="panel-heading">Beschikbare kolommen</p>

          <a v-for="columnId in available" :key="columnId" class="panel-block" @click="toggle(columnId)">
            <span class="panel-icon is-pulled-right">
              <i class="fas fa-plus" aria-hidden="true"></i>
            </span>
            {{ getColumnName(columnId) }}
          </a>
        </nav>
      </div>

      <div class="column">
        <nav class="panel">
          <p class="panel-heading">Geselecteerde kolommen</p>

          <draggable v-model="included" @start="drag=true" @end="drag=false">
            <a v-for="columnId in included" :key="columnId" class="panel-block" @click="toggle(columnId)">
              <span class="panel-icon is-pulled-right">
                <i class="fas fa-minus" aria-hidden="true"></i>
              </span>
              {{ getColumnName(columnId) }}
            </a>
          </draggable>
        </nav>
      </div>
    </div>

    <save-buttons
      @save="save"
      @cancel="close">
    </save-buttons>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Draggable from 'vuedraggable'
import SaveButtons from '@/components/modules/SaveButtons'

export default {
  components: {
    Draggable,
    SaveButtons
  },
  data () {
    return {
      name: null,
      included: [],
      available: []
    }
  },
  computed: {
    ...mapGetters({
      table: 'tables/table',
      report: 'reports/report',
      columns: 'columns/columns'
    })
  },
  created () {
    this.$store.dispatch('reports/loadForAdmin', {
      id: this.$route.params.reportId
    })

    this.$store.dispatch('tables/loadForAdmin', {
      id: this.$route.params.tableId
    })
  },
  watch: {
    table () {
      if (this.table) {
        this.name = this.report.name
        this.loadColumns()
      }
    }
  },
  methods: {
    getColumnName (columnId) {
      return this.columns.find(x => x.id === columnId).tabname
    },
    loadColumns () {
      this.included = this.report.column_ids.map(columnId => columnId)
      this.available = this.table.column_ids.filter(columnId => !this.included.includes(columnId))
    },
    toggle (columnId) {
      if (this.included.includes(columnId)) {
        this.included.splice(this.included.findIndex(x => x === columnId), 1)
        this.available.push(columnId)
      } else {
        this.available.splice(this.available.findIndex(x => x === columnId), 1)
        this.included.push(columnId)
      }
    },
    save () {
      this.$store.dispatch('reports/save', {
        name: this.name,
        id: this.report.id,
        column_ids: this.included,
        table_id: this.report.table_id
      })

      this.close()
    },
    close () {
      this.$router.go(-1)
    }
  }
}
</script>
